<template>
  <section class="play container">
    <h1>Pick a Challenge to Play</h1>
    <div class="note anonymous-note" v-if="isAnonymous">
      You are playing anonymously, your answers will not be saved. Create an account or login to save your results.
    </div>
    <div class="filters flex row center justify-center">
      <button @click="allFilter_clickHandler" :class="filterAllClass">All</button>
      <button @click="whenAndWhereFilter_clickHandler" :class="filterWhenAndWhereClass"><i class="fas fa-street-view" />&nbsp;When and Where</button>
      <button @click="photoHunt_clickHandler" :class="filterPhotoHuntClass"><i class="fas fa-crosshairs" />&nbsp;Photo Hunt</button>
    </div>
    <div class="flex row center wrap space-around">
      <challenge-link :challenge="challenge" v-for="challenge in challenges" v-bind:key="challenge.id" />
      <div v-if="challenges.length === 0">You have answered all existing challenges.</div>
    </div>
  </section>
</template>

<script>
import GlobalMixin from '~/mixins/GlobalMixin';
import ChallengeLink from '~/components/ChallengeLink';
import { CHALLENGE_TYPE_HUNT, CHALLENGE_TYPE_WHEN_AND_WHERE } from '~/constants/PQConstants';
import './index.scss';

export default {
  components: {
    ChallengeLink
  },
  mixins: [
    GlobalMixin
  ],
  data() {
    return {
      error: undefined,
      challenges: [],
      filter: undefined
    };
  },
  computed: {
    filterWhenAndWhereClass() {
      return this.filter === CHALLENGE_TYPE_WHEN_AND_WHERE ? 'selected' : 'deselected';
    },
    filterPhotoHuntClass() {
      return this.filter === CHALLENGE_TYPE_HUNT ? 'selected' : 'deselected';
    },
    filterAllClass() {
      return this.filter === undefined ? 'selected' : 'deselected';
    },
    isAnonymous() {
      return !this.$auth.user;
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.$pqapi.getRandomChallenges({ 
          count: 12, 
          type: this.filter,
          $auth: this.$auth 
        }).then(challenges => this.challenges = challenges);
    },
    whenAndWhereFilter_clickHandler() {
      if (this.filter !== CHALLENGE_TYPE_WHEN_AND_WHERE) {
        this.filter = CHALLENGE_TYPE_WHEN_AND_WHERE;
        this.reload();
      }
    },
    photoHunt_clickHandler() {
      if (this.filter !== CHALLENGE_TYPE_HUNT) {
        this.filter = CHALLENGE_TYPE_HUNT;
        this.reload();
      }
    },
    allFilter_clickHandler() {
      if (this.filter !== CHALLENGE_TYPE_HUNT) {
        this.filter = undefined;
        this.reload();
      }
    }
  }
}
</script>
